module.exports = __webpack_public_path__ + "static/queen-of-fashion-defda9e1f5f3482aacea3fe99a75aabb.jpg";